import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSuperscript: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconSuperscript"><Path d="M21.25 11.25H16.75C16.75 8.75 21.25 8.43516 21.25 5.9459C21.25 4.62271 20.2485 3.75 19.0058 3.75C17.9336 3.75 17.1989 4.39493 16.9025 5.24555" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/><Path d="M2.75 5.75L13.25 18.25M13.25 5.75L2.75 18.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconSuperscript;
